export const RATING_LABELS: { [index: number]: string } = {
    0: "NA - I did not attend this meeting",
    1: 'No-show or complete miss',
    2: 'Not the best use of my time',
    3: 'Worthwhile, I\'d do more of these',
    4: 'Great call, excited for the relationship',
};

export const RATING_LABELS_SHORT: { [index: number]: string } = {
    0: "NA - Did not attend",
    1: 'No-show or complete miss',
    2: 'Not the best use of time',
    3: 'Worthwhile, would do more',
    4: 'Great, excited for the relationship',
}; 